module.exports = __webpack_public_path__ + "static/media/microscope.4b19193f.webp";